import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { BusinessType, BusinessWrapper, InteractionType, KeyValues3, LocalService, Status, SummaryType } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-explore-products',
  templateUrl: './explore-products.component.html',
  styleUrl: './explore-products.component.scss'
})
export class ExploreProductsComponent {
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;
  businessId = ''; wrapper: BusinessWrapper; address: KeyValues3;
  businessType: BusinessType = BusinessType.EndCustomer;
  availableBusinessTypes: BusinessType[] = []; tableId: string = '0';

  isSummaryDetailPopupOpen = false; selectedSummaryId = ''; selectedSummaryType = SummaryType.Business;
  isRequeCheckInitiated = false;

  constructor(public localService: LocalService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService, private sellerManagementService: SellerManagementService) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.businessId = routeParams.businessId;
      this.ctryCode = routeParams.ctryCode;
      this.localService.selected.countryCode = this.ctryCode;
      this.userId = routeParams.userId;
      this.tableId = routeParams.tableId;
      this.interactionType = routeParams.interactionType;
      if (!this.localService.reques) {
        this.onCheckReques();
      } else {
        this.onInitiate();
      }
    });
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.onInitiate();
          }
        });
      } else {
        this.onInitiate();
      }
    } else {
      this.onInitiate();
    }
  }

  onInitiate() {
    if (this.userId) {
      this.localService.saveUrl();
      this.localService.setBasicParams(this.ctryCode, this.userId, this.interactionType, this.businessId);
      this.onLoad();
    } else {
      this.onLoad();
    }
  }

  onLoad() {
    this.sellerManagementService.getBusiness(this.businessId, false, this.ctryCode).subscribe(result => {
      this.wrapper = result;
      this.availableBusinessTypes = result.expectedBusinessTypes.map(x => parseInt(x));
      this.onSetValue();
    });
  }

  onSetValue() {
    if (this.wrapper.languageContentsAddress.length > 0) {
      const temp = this.wrapper.languageContentsAddress.find(x => x.v1 == this.localService.selected.applicationLanguage);
      this.address = temp ? temp : this.wrapper.languageContentsAddress[0];
    } else {
      this.address = undefined;
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.localService.galleryViewUrl = this.wrapper.content.values;
      } break;
      case 2: {
        if (this.businessId) {
          this.selectedSummaryId = this.businessId;
          this.isSummaryDetailPopupOpen = true;
        }
      } break;
      case 3: {
        if (this.businessId) {
          this.localService.copyContent(environment.url.app + '?redirect=bv/' + this.ctryCode + '/' + this.businessId + '/0');
        }
      } break;
      case 4: {
        if (this.businessId) {
          this.router.navigate(['/billing', this.ctryCode, this.localService.selected.user, InteractionType.User, this.businessId, '0']);
        }
      } break;
    }
  }

  onClosesSummaryDetailsPopup(event?: any) {

  }
}
